module.exports = {"dashboard":"Instrumententafel","search":"Suche","calendar":"Kalender","mailbox":"Briefkasten","widgets":"Widgets","social":"Sozial","charts":"Diagramme","media":"Medien","overlays":"Überlagerungen","snackbar":"Imbissbude","authorization":"Genehmigung","login":"Anmeldung","users":"Benutzer"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de.json
// module id = B4A8
// module chunks = 1